import { api, TCustomAxiosResponse } from '..';
import { apiPaths } from '@/services/api/paths';
import { TRosterUserPeerSupportCertificateInfo } from '@/types/Roster.types';
import {
  TPeerSupportContactInfo,
  TPeerSupportContactEventCreation,
  TPeerSupportProfileInfo,
} from '@/types/PeerSupport.types';
import { TUser } from '@/types/User.types';
import { TOrganizationDashboard } from '@/types/Organization.types';
import { THealthDomainScores } from '@/types/Health.types';
import { WELLNESS_DATA_MULTIPLIER } from '@/constants';

export const updateNewPeerSupportProfilePut = async (peerSupportInfo: TPeerSupportProfileInfo) => {
  const { data } = await api.put<TCustomAxiosResponse<TUser>>(apiPaths.peerSupport.profile, {
    ...peerSupportInfo,
  });
  const updatedPeerSupport = data.data;

  return updatedPeerSupport;
};

export const upgradeMemberToPeerSupportPost = async (
  organizationId: string,
  userId: string,
  peerSupportUpgradeInfo: TRosterUserPeerSupportCertificateInfo,
) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.upgradeToPeerSupport(organizationId, userId),
    {
      certificateId: peerSupportUpgradeInfo.certificateId,
      validationStartDate: peerSupportUpgradeInfo.dateOfIssue,
      validationEndDate: peerSupportUpgradeInfo.validUntil,
    },
  );

  return data.data;
};

export const peerSupportDashboardGet = async (monthDate: string): Promise<TOrganizationDashboard> => {
  const [year, month] = monthDate.split('-');
  const { data } = await api.get<TCustomAxiosResponse<TOrganizationDashboard>>(
    `${apiPaths.peerSupport.dashboard}${monthDate ? `?month=${month}&year=${year}` : ''}`,
  );

  const wellnessDomainsMultiplied = data.data.score.domains;

  for (const key in wellnessDomainsMultiplied) {
    wellnessDomainsMultiplied[key as keyof THealthDomainScores] *= WELLNESS_DATA_MULTIPLIER;
  }

  return { ...data.data, score: { ...data.data.score, domains: wellnessDomainsMultiplied } };
};

export const downgradePeerSupportToMemberPost = async (organizationId: string, userId: string) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(
    apiPaths.organization.downgradeToEmployee(organizationId, userId),
  );

  return data.data;
};

// organizationId: string, userId: string, type: TOrganizationEventType, data:
export const createContactEventPost = async (eventInfo: TPeerSupportContactEventCreation) => {
  const { data } = await api.post<TCustomAxiosResponse<unknown>>(apiPaths.peerSupport.outreach, eventInfo);

  return data.data;
};

export const requestPeerSupportContactPost = async (peerSupportContactInfo: TPeerSupportContactInfo) => {
  const response = await api.post<TCustomAxiosResponse<TPeerSupportContactInfo>>(
    apiPaths.peerSupport.request,
    peerSupportContactInfo,
  );

  return response;
};
